export const HOME = '/'

export const AUTH = '/auth'
export const LOGIN = AUTH + '/login'
export const PORTAL_LOGIN = AUTH + '/portal-login'

export const COMPANY_LIST = '/company-list'

// In-app notifications (served by portal-service, public.notifications scoped to ERPBOI_CHAT).
// Reached from the profile menu, not feature-gated: the feed is the caller's own.
export const NOTIFICATIONS = '/notifications'

// Where "/" and a denied route land: it forwards to Chats when the user holds it, else shows a
// "nothing assigned" notice. It must NOT be feature-guarded (RequireFeature redirects here).
export const LANDING = '/home'

// --- CHAT feature urls. These are the PERMISSION KEYS stored in auth.features.url (app
// ERPBOI_CHAT, seeded by chat-service/sql/chat_02_catalog.sql) and compared by exact string
// equality. Do not rename one without an in-place UPDATE of its row in BOTH databases.
// auth.features.url is unique across every app, hence the /chat prefix on each.

/** CHAT_MSG: use chat. Also the route of the messenger itself (WhatsApp-style layout). */
export const CHATS = '/chats'
export const CHAT_CONVERSATION: (p: {id: string}) => string = ({id}) => `${CHATS}/${id}`
/** CHAT_GROUP: create groups. A permission key only: "New group" is a panel inside Chats. */
export const CHAT_NEW_GROUP = CHATS + '/new-group'
/** CHAT_ADMIN: groups and channels (the admin list page), settings, channel sync. */
export const CHAT_ADMIN = '/chat-admin'
/** The admin settings form. Not a feature url of its own: guarded by CHAT_ADMIN. */
export const CHAT_ADMIN_SETTINGS = CHAT_ADMIN + '/settings'
/** CHAT_COMPLIANCE: the read-only review of every conversation. COMPANY_ADMIN AND the explicit grant. */
export const CHAT_COMPLIANCE = '/chat-compliance'
/** Message search across every conversation. Guarded with the list (the server checks every read). */
export const CHAT_COMPLIANCE_SEARCH = CHAT_COMPLIANCE + '/search'
/** The access log of the review (who looked at what). Guarded with the list. */
export const CHAT_COMPLIANCE_LOG = CHAT_COMPLIANCE + '/access-log'
/** One conversation's read-only transcript. Guarded with the list (the server checks every read). */
export const CHAT_COMPLIANCE_VIEW: (p: {id: string}) => string = ({id}) =>
  `${CHAT_COMPLIANCE}/${id}`
